import { ZfBox } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useProjectionCashFlowSettings, useSurplusSettings, useUpdateProjectionCashFlowItemSettings, useUpdateProjectionCashFlowSettings } from '../../api';
import { CashOccurrenceType } from '../../enums';
import { CashflowSettingBox } from '../settings-drawer';
import { RecurringCashflowsModal } from './RecurringCashflowsModal';
import { SurplusOverrideToggle } from './surplus/SurplusOverrideToggle';

export const RecurringCashflowSettings: FunctionComponent = () => {
    const { t } = useTranslation();
    const { data: cashFlowSettings } = useProjectionCashFlowSettings();
    const { data: surplusSettings } = useSurplusSettings();
    const cashFlows = surplusSettings?.enabled ? surplusSettings?.itemsSettings : cashFlowSettings?.itemsSettings;

    const updateCashFlowSettings = useUpdateProjectionCashFlowSettings();
    const updateCashFlowItem = useUpdateProjectionCashFlowItemSettings();

    const [detailsOpen, setDetailsOpen] = useState(false);

    return (
        <CashflowSettingBox
            title={t('recurringCashflows')}
            cashOccurrenceType={CashOccurrenceType.RECURRING}
            settings={cashFlowSettings}
            cashflowItems={cashFlows ?? []}
            updatePanelSettings={updateCashFlowSettings}
            updateItemSettings={updateCashFlowItem}
            showButton={true}
            disableButton={!cashFlowSettings?.enabled}
            onButtonClick={() => setDetailsOpen(true)}
            detailHeader={
                <ZfBox style={{ margin: 'var(--padding-vertical-xs) var(--padding-horizontal-sm)' }}>
                    <SurplusOverrideToggle isCustomLabel={true} cashflowSettingsEnabled={!!cashFlowSettings?.enabled} label={t('useIncomeExpenseSurplus')} />
                    <RecurringCashflowsModal
                        updateCashflowItem={updateCashFlowItem}
                        cashflowSettings={cashFlowSettings}
                        open={detailsOpen}
                        handleClose={() => setDetailsOpen(false)}
                    />
                </ZfBox>
            }
        />
    );
};
